import { jsx } from "react/jsx-runtime";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import { validateTidalLicense } from "../../base/index.js";
function ThumbDownAlt(props) {
  return /* @__PURE__ */ jsx(
    ThumbDownAltIcon,
    {
      "data-testid": "ThumbDownAlt",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ThumbDownAlt",
      "data-tidal-icon-meta": "ratings,sentiments"
    }
  );
}
ThumbDownAlt.tidalIconMeta = {
  categories: "ratings,sentiments",
  name: "ThumbDownAlt"
};
validateTidalLicense();
export {
  ThumbDownAlt
};
//# sourceMappingURL=ThumbDownAlt.js.map
